import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Table, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import InputTreeSelect from '../../commons/form/InputTreeSelect'
import FaqMasterModalPage from '../../../containers/masters/Faq/FaqMasterModalPage'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class FaqMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchUO: null,
        searchSection: null,
        searchQuestion: null
      },
      ouId: null
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchFaqList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchFaqList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleOrganizedUnitChange (filterUO) {
    this.setState({ filter: { ...this.state.filter, searchUO: [filterUO], searchSection: [] }, ouId: filterUO })
    this.props.change('filters.fasqSection', [])
    this.props.actions.fecthFaqSectionCombo(filterUO)
  }

  handleQuestionChange (filterText) {
    if (this.state.filter.searchQuestion !== filterText) {
      this.setState({ filter: { ...this.state.filter, searchQuestion: filterText } })
    }
  }

  handleSectionChange (searchSection) {
    this.setState({ filter: { ...this.state.filter, searchSection: [searchSection] } })
  }

  searchFaqListEventHandler () {
    const faqFilter = { ...this.props.filter, ...this.state.filter, page: 1 }
    this.props.actions.fetchFaqList(faqFilter)
  }

  componentDidMount () {
    this.props.actions.openFaqMaster()
    this.props.actions.fetchFaqList()
    this.props.actions.fecthFaqSectionCombo(null)
  }

  resetFilters () {
    this.setState({
      filter: {
        searchUO: null,
        searchSection: null,
        searchQuestion: null
      },
      ouId: null
    }, () => { this.searchFaqListEventHandler() })
  }

  render () {
    const {
      t, faqList, pagesCount, faqCount, filter,
      filter: { page },
      combos: { UOTreeCombo, faqSectionCombo },
      actions: { deleteFaq, openFaqModal, recoverFaqModal, fetchFaqList }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'faqMastersPage' })
    const tKey = 'MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="recoverTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchQuestion || this.state.filter.searchSection || this.state.filter.searchUO || this.state.ouId)

    return (
      <div id='faqMaster' className="inner-results-panel">
        <div className="section-results-header">
          <div className="section-header-title">
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
            <h4>{t(`${secMapMasters.title}`)}</h4>
            <Button className="_Btn new" onClick={() => openFaqModal()}>
              <i className='iDocIcon-add-plus'></i> {t('MASTERS.ADD')} {t(`${secMapMasters.title}`)}
            </Button>
          </div>
          <div className='filters'>
            <div className="search-form">
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.organizedUnitId"
                placeholder={t(`${tKey}FAQ.ORGANIZED_UNIT`)}
                controlLabel={t(`${tKey}FAQ.ORGANIZED_UNIT`)}
                multi={false}
                valueKey="value"
                labelKey="label"
                childrenKey="children"
                colSm={3}
                options={UOTreeCombo}
                onInputChange={(value) => this.handleOrganizedUnitChange(value)}
                className='dashboard-select'
                showSearch={false}
              />
              <Field
                component={InputTreeSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.fasqSection"
                controlLabel={t(`${tKey}FAQ.FAQ_SECTION`)}
                placeholder={t(`${tKey}FAQ.FAQ_SECTION`)}
                multi={false}
                valueKey="id"
                labelKey="value"
                options={faqSectionCombo}
                allowClear= {true}
                onInputChange={(value) => this.handleSectionChange(value)}
                className='dashboard-select'
              />
              <Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="filters.question"
                controlLabel={t(`${tKey}FAQ.FAQ_QUESTION`)}
                placeholder={t(`${tKey}FAQ.FAQ_QUESTION`)}
                onInputChange={(value) => this.handleQuestionChange(value)}
              />
              <div className="search-form-actions flexInLine al-R">
                <Button
                  className={'_Btn accept'}
                  onClick={() => this.searchFaqListEventHandler()}
                  onKeyDown={(e) => handleKeyDown(e)}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'_Btn accept stk ' + (hasFilters ? ' ' : 'disabled')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t(`${tKey}RESET_BUTTON`)}
                </Button>
              </div>
            </div>
          </div>
        </div>
        <div className='section-results-body'>
          <div className={'searchResoultsContainer'}>
            <div className="table-wrapper" key="table-wrapper">
              {/* table */}
              {(faqList.length !== 0) &&
              <Table className="editable-table" hover responsive>
                <thead>
                  <tr>
                    <th onClick={() => { this.changeOrder('organizedUnitName') }}>
                      {t(`${tKey}FAQ.ORGANIZED_UNIT`)} <i className={this.getSortIcon('organizedUnitName')} />
                    </th>
                    <th onClick={() => { this.changeOrder('section') }}>
                      {t(`${tKey}FAQ.FAQ_SECTION`)} <i className={this.getSortIcon('section')} />
                    </th>
                    <th onClick={() => { this.changeOrder('question') }}>
                      {t(`${tKey}FAQ.FAQ_QUESTION`)} <i className={this.getSortIcon('question')} />
                    </th>
                    <th onClick={() => { this.changeOrder('answer') }}>
                      {t(`${tKey}FAQ.FAQ_ANSWER`)} <i className={this.getSortIcon('answer')} />
                    </th>
                    <th className='actions'>
                      {t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {faqList && faqList.map((faqMaster, idx) => (
                    <tr key={idx} className={faqMaster.isDeleted ? 'is-deleted' : '' }>
                      <td>{faqMaster.organizedUnitName}</td>
                      <td>{faqMaster.section}</td>
                      <td>{faqMaster.question}</td>
                      <td><div dangerouslySetInnerHTML={{ __html: faqMaster.answer }}/></td>
                      <td className='actions'>
                        {!faqMaster.isDeleted ? (
                          <div>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <a className='_Btn accept stk o-icn ' onClick={() => openFaqModal(faqMaster.faqId)}>
                                <i className="iDocIcon-edit" />
                              </a>
                            </OverlayTrigger>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <a className='_Btn cancel stk o-icn ' onClick={() => deleteFaq(faqMaster.faqId)}>
                                <i className="iDocIcon-delete-forever" />
                              </a>
                            </OverlayTrigger>
                          </div>
                        ) : (
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <a className='_Btn accent stk o-icn ' onClick={() => recoverFaqModal(faqMaster.faqId)}>
                              <i className='iDocIcon-undo-back' />
                            </a>
                          </OverlayTrigger>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              }
              {(faqList === null || faqList === undefined || faqList.length === 0) &&
                <p className="no_results" >{t(`${tKey}FAQ.RESULTS_NOT_FOUND`)}</p>
              }
              <div className="section-faqmaster-footer">
                <nav key={1} className="text-center">
                  <IDocCarPagination id="btn_pag_faqmaster" page={page} pagesCount={pagesCount} totalRows={faqCount}
                    onSelectAction={(value) => fetchFaqList({ ...filter, ...this.state.filter, page: value })}
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
        <FaqMasterModalPage/>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listFAQsMaster'
})(FaqMaster)
